import React from 'react';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { calculateUnlinkedObject } from '../elements/BaseElement.jsx';
import { List, Map } from 'immutable';
import ElementBuilder from '../elements/ElementBuilder.jsx';
import { connect } from 'react-redux';
import { refLoad } from '@/component/dict/complex/product/store';
import Alert from '@/util/Alert.jsx';
import { REF_NAME, REF_PATH } from '@/component/dict/complex/product/Const';
import 'rc-select/assets/index.css';
import { getDealListWrapper } from '../store/DealsWrapper';
import { filterProducts } from '../Atoms.jsx';
import { stopLinking } from '@/store/links.store';
import Quantity from '../elements/Quantity.jsx';
import { saveLinkChanges } from '../store/deal.store';
import _ from 'lodash';
import { validate } from './AtomLinksEdit';
import { LinkHeader } from './LinkHeader';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import { REF_NAME as DT_REF_NAME,
  REF_PATH as DT_REF_PATH } from '@/component/dict/simple/deliveryterm/Const';
import { MainComponentBox } from '@/util/util.jsx';
import { saveSelectedAtoms } from '@/store/links.store.js';
import { handleFormChanged } from '@/store/allaround.store.js';

class LinkExisting extends React.Component {
  constructor(props) {
    super(props);
    this.filterData = this.filterData.bind(this);
    this.resize = this.resize.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.cancel = this.cancel.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.save = this.save.bind(this);
    this.setData = this.setData.bind(this);
    this.renderShowMore = this.renderShowMore.bind(this);
    this.init = false;
    this.state = {
      originalData: undefined,
      data: undefined,
      alertMsg: undefined,
      showAlert: false,
      saveAllowed: true,
      alerts: {},
      link: {},
      disabled: true,
      oddData: [],
      showOdd: false,
    };
  }
  componentWillMount() {
    getDealListWrapper(this.props.dealFrom);
    getDealListWrapper('transport');
    getSimpleListWrapper(DT_REF_NAME, DT_REF_PATH);
    if (this.props.data) {
      this.filterData(this.props);
    }
    this.findParentAtom(this.props);
    this.findBaseLink(this.props);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
  }
  componentWillReceiveProps(props) {
    this.filterData(props);
    this.findParentAtom(props);
    this.findBaseLink(props);
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextState.alerts !== this.state.alerts) {
      const data = nextProps.data ? nextProps.data : new List();

      const newStateData = this.setData(data,
        this.createFilter(nextProps), nextProps.dealTo, nextState.alerts);
      this.setState(newStateData);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
    this.props.saveSelectedAtoms(new Map());
  }

  setData(data, usedFilters, dealTo, alerts) {
    const filteredData = filterProducts(usedFilters, data, dealTo);
    const filteredIds = filteredData.map(elem => elem.get('id')).toJS();
    const oddData = filterProducts(usedFilters, data, dealTo, false)
      .filter(elem => !filteredIds.includes(elem.get('id')));
    return {
      data: this.getDataToDisplay(filteredData, dealTo, alerts),
      oddData: this.getDataToDisplay(oddData, dealTo, alerts, filteredData.size),
    };
  }

  getDataToDisplay(data, type, alerts, initialIdx = 0) {
    return data.map((elem, id) => (
      <Row key={initialIdx + id} style={{ display: 'block', width: '100%' }}>
        <Col sm={12}>
          <ElementBuilder
            key={`atom-${initialIdx + id}`}
            data={elem}
            handleSelected={this.handleSelected}
            dealIdx={initialIdx + id}
            type={`connect${type}`}
            mode="radio"
            alerts={alerts}
          />
        </Col>
      </Row>
    )).toArray();
  }

  createFilter(props) {
    const usedFilters = props.productTypeFilter ? props.productTypeFilter : undefined;
    if (usedFilters) {
      return usedFilters.set('shipment',
        [usedFilters.get('shipmentFrom'), usedFilters.get('shipmentTo')]);
    }
    return usedFilters;
  }

  findBaseLink(props) {
    if (this.init === false && props.productTypeFilter) {
      const existingLink = props.productTypeFilter.get(`${props.dealFrom}Link`)
        .get(props.existingLinkIdx);
      if (existingLink) {
        this.setState({ existingLink, link: existingLink.toJS() });
        this.init = true;
      }
    }
  }
  cancel() {
    this.props.stopLinking();
  }
  createParentAtom(props, hostDeal) {
    // eslint-disable-next-line
    if (hostDeal && props.productTypeFilter && props.dealFrom){
      let atom = hostDeal;
      if (atom) {
        atom = atom
          .delete('products')
          .set('products', List.of(props.productTypeFilter));
        return (
          <Row>
            <ElementBuilder
              data={atom}
              mode="parentatom"
              dealIdx="parentatom"
              type={`connect${props.dealFrom}`}
            />
          </Row>);
      }
    }
    return undefined;
  }
  findParentAtom(props) {
    if (props.productTypeFilter && props.dealsFromList && props.dealFrom
     && props.productToLinkIdx !== undefined && props.productToLinkIdx !== null) {
    // eslint-disable-next-line
    const dealFromId = props.productTypeFilter.get(props.dealFrom);
      let hostDeal = props.dealsFromList.find(deal => deal.get('id') === dealFromId);
      if (!hostDeal) {
        hostDeal = new Map();
        hostDeal = hostDeal.set('products', new List());
      }
      const parentAtom = this.createParentAtom(props, hostDeal);
      if (parentAtom) {
        this.setState({ parentAtom });
      }
    }
  }
  handleSelected(domElemId, dealid, atom, productDomElemId) {
    const newLink = this.state.link;
    newLink[`${this.props.dealTo}Product`] = atom.get('id');
    newLink[`${this.props.dealTo}Id`] = dealid;
    const alerts = {};
    const transport = this.props.transportList.find(tr => tr.get('id') == newLink.transport);
    alerts[`${productDomElemId}`] = validate(dealid, this.props.productTypeFilter,
      atom, this.props.dealTo, this.props.dealFrom, this.props.deliveryTerms, transport);
    let data = this.props.data ? this.props.data : new List();
    const newStateData =
      this.setData(data, this.createFilter(this.props), this.props.dealTo, alerts);
    data = newStateData.data;

    const { existingLink } = this.state;
    const selectedProductUnlinked = calculateUnlinkedObject(atom,
      atom.get(`${this.props.dealTo}Link`));
    if (existingLink.get('billLandingQuantity')
      && selectedProductUnlinked.quantityMax < existingLink.get('billLandingQuantity')) {
      this.updateQuantity({ failed: true });
    }
    this.setState({ link: newLink,
      alerts,
      selectedProductUnlinked,
      ...newStateData,
    });

    let atoms = new Map();

    const id = atom.get('id');
    const values = new Set()
      .add(id);
    atoms = atoms
      .set(dealid, values);

    this.props.saveSelectedAtoms(atoms);

    this.setState({ disabled: false });
  }

  resize() {
    this.forceUpdate();
  }

  filterData(props) {
    if (props.productTypeFilter && !props.productTypeFilter.get('product')) {
      this.setState({ showAlert: true, alertMsg: 'Product is not defined!' });
      return;
    }
    let data = props.data ? props.data : new List();
    const newStateData =
      this.setData(data, this.createFilter(props), props.dealTo, this.state.alerts);
    data = newStateData.data.concat(newStateData.oddData);
    if (props.data &&
        props.data.size !== 0 &&
        data.length === 0) {
      this.setState({ showAlert: true, alertMsg: `No records for ${props.dealTo}s!` });
    } else {
      this.setState({
        originalData: data,
        total: data.length,
        ...newStateData,
      });
    }
  }

  hideAlert() {
    this.setState({ showAlert: false, alertMsg: '' });
    this.cancel();
  }
  save() {
    this.props.saveLinkChanges(this.props.productToLinkIdx,
      this.props.existingLinkIdx, this.state.link);
    this.props.stopLinking();
    this.props.handleFormChanged();
  }
  updateQuantity(quantityObject) {
    const updatedLink = Object.assign({},
      this.state.link,
      _.pick(quantityObject,
        ['quantity', 'quantityMin', 'quantityMinP', 'quantityMaxP', 'quantityMax',
          'billLandingQuantity', 'billLadingDate']));
    this.setState({ link: updatedLink });
    if (quantityObject.failed) {
      this.quantityFailed = true;
    } else {
      this.quantityFailed = false;
    }
    this.updateSaveAllowed();
  }
  updateSaveAllowed() {
    if (!this.quantityFailed) {
      this.setState({ saveAllowed: true });
    } else {
      this.setState({ saveAllowed: false });
    }
  }

  renderShowMore() {
    if (this.state.oddData.length && !this.state.showOdd) {
      return (
        <Row>
          <Col
            mdOffset={this.props.dealTo == 'purchase' ? 0 : 8} md={4}
            style={{ paddingTop: '10px', textAlign: 'center' }}
          >
            <Button
              bsStyle={'primary'}
              onClick={() => this.setState({ showOdd: true })}
            >Show more</Button>
          </Col>
        </Row>
      );
    }
    return '';
  }

  render() {
    const header = (<LinkHeader
      caption={'New link'}
      disabled={!this.state.saveAllowed || this.state.disabled || this.props.quantityFailed}
      stepForward={this.save}
      stepBack={this.cancel}
    />);
    return (
      <MainComponentBox secondNavBar={header} className="deals" withBreadcrumb>
        <Alert
          show={this.state.showAlert} message={this.state.alertMsg} hideAlert={this.hideAlert}
        />
        <div className={'link-to-halflink'}>
          <div
            style={{ display: 'flex',
              flexDirection: this.props.dealFrom == 'purchase' ? 'row' : 'row-reverse' }}
          >
            <div style={{ flexGrow: 2 }}>
              <div
                className={'link-existing'}
                style={{ flexDirection: this.props.dealFrom == 'purchase' ? 'row' : 'row-reverse' }}
              >
                <div className={'existing-deal'}>
                  {this.state.parentAtom}
                </div>
                <div className={'existing-quantity'}>
                  <Quantity
                    onChangeFunc={e => this.updateQuantity(e)} data={this.state.existingLink}
                    unlinkedObject={this.state.selectedProductUnlinked} id="existing"
                    isLinking showBLQuantity
                  />
                </div>
              </div>
            </div>
            <div style={{ flex: '1 0 500px' }}>
              {this.state.data ?
                this.state.data
                : <span />}
              {this.state.showOdd && this.state.oddData ?
                this.state.oddData
                : <span />}
            </div>
          </div>
          {this.renderShowMore()}
        </div>
      </MainComponentBox>
    );
  }
}

LinkExisting.propTypes = {
  saveSelectedAtoms: React.PropTypes.func.isRequired,
  dealTo: React.PropTypes.string.isRequired,
  dealFrom: React.PropTypes.string.isRequired,
  loadProducts: React.PropTypes.func.isRequired,
  data: React.PropTypes.object,
  handleSelected: React.PropTypes.func,
  mode: React.PropTypes.string,
  saveAllowed: React.PropTypes.bool,
  stopLinking: React.PropTypes.func,
  existingLinkIdx: React.PropTypes.number,
  productToLinkIdx: React.PropTypes.number,
  saveLinkChanges: React.PropTypes.func,
  quantityFailed: React.PropTypes.bool,
  productTypeFilter: React.PropTypes.object,
  deliveryTerms: React.PropTypes.object,
  transportList: React.PropTypes.object,
  handleFormChanged: React.PropTypes.func,
};

export default connect(
  (store, props) => ({
    filter: store.getIn(['data', 'deals', 'list', 'filters', props.dealTo]),
    data: store.getIn(['data', 'deals', 'list', props.dealTo]),
    productToLinkIdx: store.getIn(['links', 'data', 'productToLinkIdx']),
    existingLinkIdx: store.getIn(['links', 'data', 'linkIdx']),
    quantityFailed: store.getIn(['links', 'quantity', 'existing', 'failed']),
    productTypeFilter: store.getIn(['links', 'data', 'productToLinkIdx']) !== undefined
      // eslint-disable-next-line
      ? store.getIn(['data', 'deals', 'deal', 'products'], List())
        .get(store.getIn(['links', 'data', 'productToLinkIdx']))
      : undefined,
    dealsFromList: store.getIn(['data', 'deals', 'list', props.dealFrom]),
    deliveryTerms: store.getIn(['references', 'simple', DT_REF_PATH], new List()),
    transportList: store.getIn(['data', 'deals', 'list', 'transport'], new List()),
  })
  , (dispatch, props) => ({
    loadProducts() {
      refLoad(dispatch, REF_NAME, REF_PATH);
    },
    stopLinking() {
      stopLinking(dispatch);
    },
    saveLinkChanges(productIdx, linkIdx, link) {
      saveLinkChanges(dispatch, props.dealFrom, productIdx, linkIdx, link);
    },
    saveSelectedAtoms: (atoms) => {
      saveSelectedAtoms(dispatch, atoms);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  }))(LinkExisting);
